<template>
  <div>
    <div class="notification is-warning is-marginless">
      <p class="is-uppercase is-size-7">
        CI-DESSOUS, LA LISTE DES DOCUMENTS DU FIL D'ACTUALITÉ VISIBLES QUE PAR LE OU LES ACQUÉREUR(S) DE CE LOGEMENT. POUR VOIR TOUS LES DOCUMENTS VISIBLES PAR TOUS LES ACQUÉREURS DU PROGRAMME, RENDEZ-VOUS DANS LA RUBRIQUE « ESPACE ACQUÉREUR » DE LA FICHE PROGRAMME.
      </p>
    </div>
    <div class="is-padding">
      <div
        v-if="allDocuments"
        class="column is-12 is-border-right is-overflow-auto is-paddingless is-border-left is-border-top is-border-right"
        style="height: auto;">
        <template v-for="(item, keyDocument, i) in allDocuments">
          <div
            class="row-width-actions-bar columns is-marginless is-gapless is-vcentered is-border-bottom"
            :key="'parent-'+i">
            <div class="column is-padding-left-large">
              <span class="has-text-dark is-size-6 "><span class="is-uppercase">{{ item.label }}</span> <span v-if="item.documents.length">({{ item.documents.length }} {{ item.label }})</span></span>
            </div>
            <div class="column is-narrow is-border-left">
              <button
                :disabled="item.documents < 1"
                class="page-header-btn is-small is-square"
                @click="toggleTable(keyDocument)">
                <span class="icon is-size-4 has-text-dark">
                  <i
                    class="fal"
                    :class="open[keyDocument] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </span>
              </button>
            </div>
          </div>
          <div
            class="is-padding-xsmall is-border-bottom"
            v-show="open[keyDocument]"
            v-for="document in item.documents"
            :key="'doc-' + Math.floor(Math.random(2) * 10000) + document.fus_id">
            <span class="is-padding-left-xxsmall is-padding-right">
              <i class="fal fa-file-pdf"></i>
            </span>
            <a
              @click="openPreview(document)"
              class="is-size-6">{{ document.filename }}</a>
          </div>
        </template>
      </div>
      <div
        class="is-padding-bottom"
        v-else>
        <b>
          Aucun document disponible
        </b>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdvBuyerSpaceDocs',
  props: {
    program: {
      type: Object
    },
    timeline: {
      type: Array
    }
  },
  data () {
    return {
      open: {}
    }
  },
  computed: {
    /**
      * all documents
      * @returns {object}
      */
    allDocuments () {
      let allDocuments = {
        pictures: {
          documents: this.pictures,
          label: 'Photos'
        },
        documents: {
          documents: this.documents,
          label: 'Documents'
        }
      }
      return allDocuments
    },
    documents () {
      if (this.timeline.length) {
        return this.timeline.filter(x => x.documents.length > 0).reduce((docList, event) => {
          return [...docList, ...event.documents]
        }, [])
      } else {
        return []
      }
    },
    pictures () {
      if (this.timeline.length) {
        return this.timeline.filter(x => x.pictures.length > 0).reduce((docList, event) => {
          return [...docList, ...event.pictures]
        }, [])
      } else {
        return []
      }
    }
  },
  watch: {
    allDocuments () {
      this.open = Object.keys(this.allDocuments).map(x => {
        return { [x]: false }
      })
    }
  },
  methods: {
    toggleTable (v) {
      this.$set(this.open, [v], !this.open[v])
    },
    /**
      * open preview document
      * @param {object} selectedDocument
      */
    openPreview (selectedDocument) {
      let params = {
        link: selectedDocument.path
      }
      this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_SAAS', params })
    }
  }
}
</script>
